import React from 'react';

const ToggleOpenClose = ({toggle}) => (
  <div>
    <a href="discussion-partner-community.htm" className="xmp-minimize" onClick={toggle}></a>
  </div>
)

export default ToggleOpenClose;



// WEBPACK FOOTER //
// ./src/components/ToggleOpenClose.js